/**
 * @generated SignedSource<<63dd51e39f473f87d0bac33ad19c6c6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectScopingPage_Query$variables = {
  projectId?: string | null;
  noStaleTasks?: boolean | null;
  fetchLazyData: boolean;
  fetchCustomFields: boolean;
  personId: string;
};
export type ProjectScopingPage_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly project: {
      readonly id: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectScopingPage_viewer">;
  } | null;
};
export type ProjectScopingPage_Query = {
  variables: ProjectScopingPage_Query$variables;
  response: ProjectScopingPage_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchCustomFields"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchLazyData"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noStaleTasks"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "personId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "new_scoping"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"new_scoping\")"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "kind": "Variable",
  "name": "noStaleTasks",
  "variableName": "noStaleTasks"
},
v11 = {
  "kind": "Variable",
  "name": "personId",
  "variableName": "personId"
},
v12 = {
  "kind": "Variable",
  "name": "projectId",
  "variableName": "projectId"
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInProjectGroup",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sprintTimeBox",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedCost",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedRevenue",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualCost",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualRevenue",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTargetPrice",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTargetMinutes",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "demo",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prefix",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "ProgramType",
  "kind": "LinkedField",
  "name": "program",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v28/*: any*/),
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectServiceProgramMemberTypeConnection",
      "kind": "LinkedField",
      "name": "members",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectServiceProgramMemberTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectServiceProgramMemberType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "role",
                  "storageKey": null
                },
                (v29/*: any*/),
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesPerEstimationPoint",
  "storageKey": null
},
v34 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000000
  },
  {
    "kind": "Literal",
    "name": "onlyProjectRegistrations",
    "value": true
  }
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesRegistered",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billableMinutesRegistered",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiced",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "retainerConflictHandled",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v47 = {
  "kind": "Literal",
  "name": "first",
  "value": 100000
},
v48 = [
  (v47/*: any*/)
],
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endYear",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endMonth",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDay",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJiraProject",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsProject",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsAccount",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsTwoWaySync",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v66 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v67 = [
  (v66/*: any*/)
],
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v70 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v73 = [
  (v8/*: any*/),
  (v14/*: any*/)
],
v74 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v73/*: any*/),
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monday",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tuesday",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wednesday",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thursday",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "friday",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "saturday",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sunday",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "concreteType": "HolidayCalendar",
  "kind": "LinkedField",
  "name": "holidayCalendar",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineCost",
  "storageKey": null
},
v90 = [
  (v65/*: any*/),
  (v8/*: any*/)
],
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineMinutes",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startFrom",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineFrom",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraId",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v103 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "readOnly",
    "storageKey": null
  }
],
v104 = {
  "condition": "fetchCustomFields",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomFieldValueV2TypeConnection",
      "kind": "LinkedField",
      "name": "customFields",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomFieldValueV2TypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v44/*: any*/),
                (v99/*: any*/),
                (v100/*: any*/),
                (v101/*: any*/),
                (v102/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v103/*: any*/),
                  "type": "TextCustomFieldValue",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomFieldDropdownOption",
                      "kind": "LinkedField",
                      "name": "options",
                      "plural": true,
                      "selections": [
                        (v8/*: any*/),
                        (v100/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "DropdownCustomFieldValue",
                  "abstractKey": null
                },
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v105 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineRevenue",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTimeAndExpenses",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineProfit",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineMargin",
  "storageKey": null
},
v110 = [
  (v47/*: any*/),
  (v10/*: any*/),
  {
    "kind": "Literal",
    "name": "simpleResponse",
    "value": true
  }
],
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCostAtCompletion",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allTotalTimeAndExpensesAtCompletion",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v114 = [
  (v8/*: any*/),
  (v113/*: any*/)
],
v115 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v117 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v118 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "JiraSyncSettingsType",
    "kind": "LinkedField",
    "name": "syncSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isJiraToForecastOneWaySync",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v8/*: any*/)
],
v119 = [
  (v66/*: any*/),
  {
    "kind": "Literal",
    "name": "onlyActive",
    "value": true
  }
],
v120 = [
  {
    "kind": "Literal",
    "name": "filterSection",
    "value": "SCOPING"
  },
  (v66/*: any*/),
  (v12/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectScopingPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "fetchCustomFields",
                "variableName": "fetchCustomFields"
              },
              {
                "kind": "Variable",
                "name": "fetchLazyData",
                "variableName": "fetchLazyData"
              },
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProjectScopingPage_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectScopingPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupCompanyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useBaseline",
                "storageKey": null
              },
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasInvoices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FinancialSourceSettings",
                "kind": "LinkedField",
                "name": "financialSourceSettings",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastRevenue",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualHours",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateDay",
                "storageKey": null
              },
              (v24/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isNoStaleTasksAllowed",
                "storageKey": null
              },
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetWork",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodBudgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budget",
                "storageKey": null
              },
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "synchBaselineAndScopingDates",
                "storageKey": null
              },
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              {
                "condition": "fetchLazyData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v34/*: any*/),
                    "concreteType": "TimeRegTypeConnection",
                    "kind": "LinkedField",
                    "name": "timeRegistrations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRegTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeRegType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v35/*: any*/),
                              (v36/*: any*/),
                              (v37/*: any*/),
                              (v38/*: any*/),
                              (v39/*: any*/),
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "task",
                                "plural": false,
                                "selections": (v9/*: any*/),
                                "storageKey": null
                              },
                              (v29/*: any*/),
                              (v44/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v45/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v46/*: any*/)
                    ],
                    "storageKey": "timeRegistrations(first:10000000,onlyProjectRegistrations:true)"
                  },
                  {
                    "alias": null,
                    "args": (v34/*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "Project_timeRegistrations",
                    "kind": "LinkedHandle",
                    "name": "timeRegistrations"
                  }
                ]
              },
              {
                "alias": null,
                "args": (v48/*: any*/),
                "concreteType": "RetainerPeriodTypeConnection",
                "kind": "LinkedField",
                "name": "retainerPeriods",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetainerPeriodTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetainerPeriodType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v14/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "available",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodLength",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodPeriodicity",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodPriceAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodHoursAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodBudgetType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodSettingIgnoreForBilling",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodSettingSubtractValue",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodSettingRollValue",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodSettingAddExpenses",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodDifferencePriceAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodDifferenceHoursAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sharedPeriodDifferenceHoursAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sharedPeriodDifferencePriceAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ignoredRolloverHours",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ignoredRolloverPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodLocked",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodLockedTime",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "retainerPeriods(first:100000)"
              },
              (v55/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useManualAllocations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remainingAutoCalculated",
                "storageKey": null
              },
              (v61/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTaskOwner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTaskFollowers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskLevels",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTaskHierarchy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useDeliverables",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v48/*: any*/),
                "concreteType": "DeliverableTypeConnection",
                "kind": "LinkedField",
                "name": "deliverables",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DeliverableTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DeliverableType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v14/*: any*/),
                          (v44/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v45/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v46/*: any*/)
                ],
                "storageKey": "deliverables(first:100000)"
              },
              {
                "alias": null,
                "args": (v48/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_deliverables",
                "kind": "LinkedHandle",
                "name": "deliverables"
              },
              (v62/*: any*/),
              (v63/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "harvestProjectId",
                "storageKey": null
              },
              (v64/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraSubtaskType",
                "storageKey": null
              },
              (v65/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnProjectEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnPhasesEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnTasksEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectType",
                "kind": "LinkedField",
                "name": "jiraCloudProject",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraCloudEpicIds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraServerProjectType",
                "kind": "LinkedField",
                "name": "jiraServerProject",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SageProjectType",
                "kind": "LinkedField",
                "name": "sageProject",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sageProjectId",
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v67/*: any*/),
                "concreteType": "StatusColumnV2TypeConnection",
                "kind": "LinkedField",
                "name": "statusColumnsV2",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusColumnV2TypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatusColumnV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "order",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "jiraStatusId",
                            "storageKey": null
                          },
                          (v68/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "statusColumnsV2(first:1000000)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v69/*: any*/),
                  {
                    "alias": null,
                    "args": (v70/*: any*/),
                    "concreteType": "RateTypeConnection",
                    "kind": "LinkedField",
                    "name": "rates",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RateTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Rate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "defaultRate",
                                "storageKey": null
                              },
                              (v71/*: any*/),
                              (v72/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "rates(first:10000)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "disabledRoles",
                    "plural": true,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v67/*: any*/),
                "concreteType": "ProjectPersonTypeConnection",
                "kind": "LinkedField",
                "name": "projectPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectPersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectPerson",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v74/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v75/*: any*/),
                              (v76/*: any*/),
                              (v77/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "initials",
                                "storageKey": null
                              },
                              (v78/*: any*/),
                              (v79/*: any*/),
                              (v80/*: any*/),
                              (v81/*: any*/),
                              (v82/*: any*/),
                              (v83/*: any*/),
                              (v84/*: any*/),
                              (v85/*: any*/),
                              (v86/*: any*/),
                              (v87/*: any*/),
                              (v88/*: any*/),
                              (v74/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Client",
                                "kind": "LinkedField",
                                "name": "client",
                                "plural": false,
                                "selections": (v9/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  (v66/*: any*/),
                                  {
                                    "kind": "Literal",
                                    "name": "idleTimeOnly",
                                    "value": true
                                  }
                                ],
                                "concreteType": "AllocationTypeConnection",
                                "kind": "LinkedField",
                                "name": "allocations",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AllocationTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Allocation",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v83/*: any*/),
                                          (v84/*: any*/),
                                          (v85/*: any*/),
                                          (v86/*: any*/),
                                          (v87/*: any*/),
                                          (v49/*: any*/),
                                          (v50/*: any*/),
                                          (v51/*: any*/),
                                          (v52/*: any*/),
                                          (v53/*: any*/),
                                          (v54/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "IdleTime",
                                            "kind": "LinkedField",
                                            "name": "idleTime",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isInternalTime",
                                                "storageKey": null
                                              },
                                              (v8/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "allocations(first:1000000,idleTimeOnly:true)"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projectPersons(first:1000000)"
              },
              {
                "alias": null,
                "args": (v67/*: any*/),
                "concreteType": "PhaseTypeConnection",
                "kind": "LinkedField",
                "name": "phases",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhaseType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v89/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "inheritDatesFrom",
                            "storageKey": null
                          },
                          (v65/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhaseProgress",
                            "kind": "LinkedField",
                            "name": "progressDetails",
                            "plural": false,
                            "selections": (v90/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhaseBaselineRoleTypeConnection",
                            "kind": "LinkedField",
                            "name": "phaseBaselineRoles",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PhaseBaselineRoleTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PhaseBaselineRoleType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v72/*: any*/),
                                      (v91/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "baselinePrice",
                                        "storageKey": null
                                      },
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectId",
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v92/*: any*/),
                          (v93/*: any*/),
                          (v94/*: any*/),
                          (v95/*: any*/),
                          (v96/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unit4Id",
                            "storageKey": null
                          },
                          (v97/*: any*/),
                          (v98/*: any*/),
                          {
                            "alias": null,
                            "args": (v70/*: any*/),
                            "concreteType": "PhasePersonTypeConnection",
                            "kind": "LinkedField",
                            "name": "phasePersons",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PhasePersonTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PhasePerson",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "availableMinutes",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "scheduledMinutes",
                                        "storageKey": null
                                      },
                                      (v29/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "phasePersons(first:10000)"
                          },
                          (v104/*: any*/),
                          (v44/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v45/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v46/*: any*/)
                ],
                "storageKey": "phases(first:1000000)"
              },
              {
                "alias": null,
                "args": (v67/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Project_phases",
                "kind": "LinkedHandle",
                "name": "phases"
              },
              {
                "alias": "baselineFinancialNumbers",
                "args": [
                  (v105/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "groupBy",
                    "value": [
                      "PHASE_BASELINE_ROLE",
                      "PHASE"
                    ]
                  }
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "groupedFinancialNumbers",
                "plural": true,
                "selections": [
                  (v106/*: any*/),
                  (v107/*: any*/),
                  (v89/*: any*/),
                  (v108/*: any*/),
                  (v109/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineRatePerHour",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineCostPerHour",
                    "storageKey": null
                  },
                  (v91/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phaseBaselineRoleId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phaseBaselineExpenseId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phaseId",
                    "storageKey": null
                  }
                ],
                "storageKey": "groupedFinancialNumbers(convertToProjectCurrency:true,groupBy:[\"PHASE_BASELINE_ROLE\",\"PHASE\"])"
              },
              {
                "alias": null,
                "args": (v67/*: any*/),
                "concreteType": "SprintTypeConnection",
                "kind": "LinkedField",
                "name": "sprints",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SprintTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Sprint",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v14/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "sprints(first:1000000)"
              },
              {
                "alias": null,
                "args": (v110/*: any*/),
                "concreteType": "TaskTypeConnection",
                "kind": "LinkedField",
                "name": "tasks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Task",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskReadOnly",
                            "kind": "LinkedField",
                            "name": "readOnly",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isReadOnly",
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "userCanDeleteTask",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "userCantDeleteTaskReason",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasInvoicedTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasLockedTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasTimeRegistrations",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "approved",
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          (v98/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "done",
                            "storageKey": null
                          },
                          (v27/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "blocked",
                            "storageKey": null
                          },
                          {
                            "condition": "fetchLazyData",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v65/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "currentPrice",
                                "storageKey": null
                              },
                              (v22/*: any*/),
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "timeLeft",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v70/*: any*/),
                                "concreteType": "TimeRegTypeConnection",
                                "kind": "LinkedField",
                                "name": "timeRegistrations",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TimeRegTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TimeRegType",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          (v35/*: any*/),
                                          (v36/*: any*/),
                                          (v38/*: any*/),
                                          (v37/*: any*/),
                                          (v40/*: any*/),
                                          (v41/*: any*/),
                                          (v42/*: any*/),
                                          (v43/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Person",
                                            "kind": "LinkedField",
                                            "name": "person",
                                            "plural": false,
                                            "selections": [
                                              (v8/*: any*/),
                                              (v72/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v44/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v45/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v46/*: any*/)
                                ],
                                "storageKey": "timeRegistrations(first:10000)"
                              },
                              {
                                "alias": null,
                                "args": (v70/*: any*/),
                                "filters": [],
                                "handle": "connection",
                                "key": "Task_timeRegistrations",
                                "kind": "LinkedHandle",
                                "name": "timeRegistrations"
                              }
                            ]
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bug",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "latestUiUpdateAt",
                            "storageKey": null
                          },
                          (v92/*: any*/),
                          (v96/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v93/*: any*/),
                          (v94/*: any*/),
                          (v95/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "estimateForecast",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "estimateForecastMinutes",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "estimateForecastPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalPriceAtCompletion",
                            "storageKey": null
                          },
                          (v111/*: any*/),
                          (v112/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "companyTaskId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canStart",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canBeSetToDone",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "highPriority",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasDependency",
                            "storageKey": null
                          },
                          (v97/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "vstsId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUnit4Task",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subTaskCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "parentTaskId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deliverableId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasChildren",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sageIntacctId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "favoured",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskProgress",
                            "kind": "LinkedField",
                            "name": "progressDetails",
                            "plural": false,
                            "selections": (v90/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": (v114/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "followers",
                            "plural": true,
                            "selections": (v114/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhaseType",
                            "kind": "LinkedField",
                            "name": "phase",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v14/*: any*/),
                              (v49/*: any*/),
                              (v50/*: any*/),
                              (v51/*: any*/),
                              (v92/*: any*/),
                              (v93/*: any*/),
                              (v94/*: any*/),
                              (v95/*: any*/),
                              (v96/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v74/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v14/*: any*/),
                              (v49/*: any*/),
                              (v50/*: any*/),
                              (v51/*: any*/),
                              (v52/*: any*/),
                              (v53/*: any*/),
                              (v54/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StatusColumnV2",
                            "kind": "LinkedField",
                            "name": "statusColumnV2",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v14/*: any*/),
                              (v68/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectType",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v32/*: any*/),
                              (v33/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v59/*: any*/),
                              (v60/*: any*/),
                              (v18/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  (v11/*: any*/)
                                ],
                                "concreteType": "ProjectPerson",
                                "kind": "LinkedField",
                                "name": "projectPerson",
                                "plural": false,
                                "selections": [
                                  (v74/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v30/*: any*/),
                              (v14/*: any*/),
                              (v31/*: any*/),
                              (v61/*: any*/),
                              (v62/*: any*/),
                              (v63/*: any*/),
                              (v64/*: any*/),
                              (v16/*: any*/),
                              (v13/*: any*/),
                              (v15/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HarvestProjectType",
                                "kind": "LinkedField",
                                "name": "harvestProject",
                                "plural": false,
                                "selections": (v9/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Unit4ProjectType",
                                "kind": "LinkedField",
                                "name": "unit4Project",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "activitiesEnabled",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v19/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskLabel",
                            "kind": "LinkedField",
                            "name": "taskLabels",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Label",
                                "kind": "LinkedField",
                                "name": "label",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v14/*: any*/),
                                  (v115/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskDismissedNotifications",
                            "kind": "LinkedField",
                            "name": "taskDismissedNotifications",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "taskOverrunPredictionDismissed",
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "assignedPersons",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              (v75/*: any*/),
                              (v76/*: any*/),
                              (v77/*: any*/),
                              (v80/*: any*/),
                              (v116/*: any*/),
                              (v78/*: any*/),
                              (v79/*: any*/),
                              (v113/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v117/*: any*/),
                            "concreteType": "DependencyTypeConnection",
                            "kind": "LinkedField",
                            "name": "thisTaskDependsOn",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "DependencyTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "DependencyType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v102/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Task",
                                        "kind": "LinkedField",
                                        "name": "thisDependsOnTask",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          (v14/*: any*/),
                                          (v95/*: any*/),
                                          (v94/*: any*/),
                                          (v93/*: any*/),
                                          (v49/*: any*/),
                                          (v50/*: any*/),
                                          (v51/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "thisTaskDependsOn(first:1000)"
                          },
                          (v104/*: any*/),
                          (v44/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v45/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v46/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v110/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_tasks",
                "kind": "LinkedHandle",
                "name": "tasks"
              },
              {
                "alias": null,
                "args": (v48/*: any*/),
                "concreteType": "AllocationTypeConnection",
                "kind": "LinkedField",
                "name": "allocations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AllocationTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Allocation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v81/*: any*/),
                          (v82/*: any*/),
                          (v83/*: any*/),
                          (v84/*: any*/),
                          (v85/*: any*/),
                          (v86/*: any*/),
                          (v87/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v72/*: any*/),
                              (v88/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectType",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isSoft",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "allocations(first:100000)"
              },
              {
                "alias": "expenseFinancialNumbers",
                "args": [
                  (v105/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "searchQuery",
                    "value": {
                      "filters": [
                        {
                          "field": "ROLE",
                          "operator": "IS",
                          "value": "Um9sZTotMQ=="
                        }
                      ]
                    }
                  }
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  (v112/*: any*/)
                ],
                "storageKey": "financialNumbers(convertToProjectCurrency:true,searchQuery:{\"filters\":[{\"field\":\"ROLE\",\"operator\":\"IS\",\"value\":\"Um9sZTotMQ==\"}]})"
              },
              {
                "alias": "totalFinancialNumbers",
                "args": [
                  (v105/*: any*/)
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  (v111/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueRecognition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "registeredMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableActualMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nonBillableActualMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  (v91/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allocationMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scopeApprovedMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "remainingMinutes",
                    "storageKey": null
                  },
                  (v106/*: any*/),
                  (v20/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedBillableMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedNonBillableMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedTotalMinutes",
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedMargin",
                    "storageKey": null
                  },
                  (v109/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "remainingCost",
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  (v89/*: any*/),
                  (v108/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableActualTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nonBillableActualTimeAndExpenses",
                    "storageKey": null
                  },
                  (v107/*: any*/),
                  (v112/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "taskRegisteredMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectRegisteredMinutes",
                    "storageKey": null
                  }
                ],
                "storageKey": "financialNumbers(convertToProjectCurrency:true)"
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          (v116/*: any*/),
          (v75/*: any*/),
          (v76/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timerStartDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "harvestUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unit4User",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "excludeFromCompanyLockedPeriod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateDay",
            "storageKey": null
          },
          (v71/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          (v81/*: any*/),
          (v82/*: any*/),
          (v83/*: any*/),
          (v84/*: any*/),
          (v85/*: any*/),
          (v86/*: any*/),
          (v87/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              (v99/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "timerTask",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraCloudEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraServerEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyIntegrationsType",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyJiraSettingsType",
                    "kind": "LinkedField",
                    "name": "jiraCloud",
                    "plural": false,
                    "selections": (v118/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyJiraSettingsType",
                    "kind": "LinkedField",
                    "name": "jiraServer",
                    "plural": false,
                    "selections": (v118/*: any*/),
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctConnectionEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleType",
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "personId"
                  }
                ],
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v74/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUsingProjectAllocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUsingMixedAllocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v70/*: any*/),
                "concreteType": "HolidayCalendarTypeConnection",
                "kind": "LinkedField",
                "name": "holidayCalendars",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HolidayCalendarTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HolidayCalendar",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": (v48/*: any*/),
                            "concreteType": "HolidayCalendarEntryTypeConnection",
                            "kind": "LinkedField",
                            "name": "holidayCalendarEntries",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HolidayCalendarEntryTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "HolidayCalendarEntry",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v14/*: any*/),
                                      (v40/*: any*/),
                                      (v41/*: any*/),
                                      (v42/*: any*/),
                                      (v44/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v45/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v46/*: any*/)
                            ],
                            "storageKey": "holidayCalendarEntries(first:100000)"
                          },
                          {
                            "alias": null,
                            "args": (v48/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "HolidayCalendar_holidayCalendarEntries",
                            "kind": "LinkedHandle",
                            "name": "holidayCalendarEntries"
                          },
                          (v44/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v45/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v46/*: any*/)
                ],
                "storageKey": "holidayCalendars(first:10000)"
              },
              {
                "alias": null,
                "args": (v70/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Company_holidayCalendars",
                "kind": "LinkedHandle",
                "name": "holidayCalendars"
              },
              {
                "alias": null,
                "args": (v119/*: any*/),
                "concreteType": "PersonTypeConnection",
                "kind": "LinkedField",
                "name": "allPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v75/*: any*/),
                          (v76/*: any*/),
                          (v44/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v45/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v46/*: any*/)
                ],
                "storageKey": "allPersons(first:1000000,onlyActive:true)"
              },
              {
                "alias": null,
                "args": (v119/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Company_allPersons",
                "kind": "LinkedHandle",
                "name": "allPersons"
              },
              (v69/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "harvestEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unit4Enabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v66/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "labelType",
                    "value": "TASK"
                  }
                ],
                "concreteType": "LabelTypeConnection",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v14/*: any*/),
                          (v115/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LabelCategory",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": (v73/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "labels(first:1000000,labelType:\"TASK\")"
              },
              {
                "alias": null,
                "args": (v67/*: any*/),
                "concreteType": "RoleTypeConnection",
                "kind": "LinkedField",
                "name": "roles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "roles(first:1000000)"
              },
              {
                "alias": null,
                "args": (v67/*: any*/),
                "concreteType": "TeamTypeConnection",
                "kind": "LinkedField",
                "name": "teams",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": (v117/*: any*/),
                            "concreteType": "TeamPersonTypeConnection",
                            "kind": "LinkedField",
                            "name": "teamPersons",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamPersonTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamPerson",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v29/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "teamPersons(first:1000)"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "teams(first:1000000)"
              },
              {
                "condition": "fetchCustomFields",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v117/*: any*/),
                    "concreteType": "CustomFieldDefinitionV2TypeConnection",
                    "kind": "LinkedField",
                    "name": "customFieldDefinitionsV2",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomFieldDefinitionV2TypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              (v8/*: any*/),
                              (v99/*: any*/),
                              (v100/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "entityType",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v103/*: any*/),
                                "type": "TextCustomField",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v45/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v46/*: any*/)
                    ],
                    "storageKey": "customFieldDefinitionsV2(first:1000)"
                  },
                  {
                    "alias": null,
                    "args": (v117/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Company_customFieldDefinitionsV2",
                    "kind": "LinkedHandle",
                    "name": "customFieldDefinitionsV2"
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v120/*: any*/),
            "concreteType": "FilterTypeConnection",
            "kind": "LinkedField",
            "name": "filters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FilterTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Filter",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "section",
                        "storageKey": null
                      },
                      (v101/*: any*/),
                      (v39/*: any*/),
                      (v44/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v45/*: any*/)
                ],
                "storageKey": null
              },
              (v46/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v120/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "Viewer_filters",
            "kind": "LinkedHandle",
            "name": "filters"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "excludeRestricted",
                "value": true
              },
              (v66/*: any*/)
            ],
            "concreteType": "ProjectTypeConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v13/*: any*/),
                      (v15/*: any*/),
                      (v14/*: any*/),
                      (v31/*: any*/),
                      (v17/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "projects(excludeRestricted:true,first:1000000)"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "companyProjectId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectServiceProjectType",
            "kind": "LinkedField",
            "name": "psProject",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProgramType",
                "kind": "LinkedField",
                "name": "psProgram",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v14/*: any*/),
                  (v115/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isViewerProgramMember",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2f43342b44d65caeb0466befa5d76dcb",
    "id": null,
    "metadata": {},
    "name": "ProjectScopingPage_Query",
    "operationKind": "query",
    "text": "query ProjectScopingPage_Query(\n  $projectId: String\n  $noStaleTasks: Boolean\n  $fetchLazyData: Boolean!\n  $fetchCustomFields: Boolean!\n  $personId: ID!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"new_scoping\")\n    project(id: $projectId) {\n      id\n    }\n    ...ProjectScopingPage_viewer_1hnnKn\n    id\n  }\n}\n\nfragment LabelDropdownJS_labels on Label {\n  color\n  name\n  id\n  category {\n    id\n    name\n  }\n}\n\nfragment ProjectHeader_project on ProjectType {\n  id\n  companyProjectId\n  ...ProjectIndicatorJS_project\n  name\n  projectColor\n  isInProjectGroup\n  projectGroupCompanyId\n  projectGroupName\n  projectGroupColor\n  useBaseline\n  budgetType\n  sprintTimeBox\n}\n\nfragment ProjectHeader_psProject on ProjectServiceProjectType {\n  name\n  psProgram {\n    id\n    name\n    color\n    prefix\n    isViewerProgramMember\n  }\n}\n\nfragment ProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment ProjectScopingPage_viewer_1hnnKn on Viewer {\n  id\n  language\n  email\n  firstName\n  lastName\n  timerStartDate\n  actualPersonId\n  harvestUser\n  unit4User\n  excludeFromCompanyLockedPeriod\n  submitLockedDateYear\n  submitLockedDateMonth\n  submitLockedDateDay\n  startDate\n  endDate\n  createdAt\n  monday\n  tuesday\n  wednesday\n  thursday\n  friday\n  saturday\n  sunday\n  availableFeatureFlags {\n    key\n    id\n  }\n  timerTask {\n    id\n  }\n  company {\n    ...genericTaskContextMenu_company\n    jiraCloudEnabled\n    jiraServerEnabled\n    sageIntacctConnectionEnabled\n    integrations {\n      jiraCloud {\n        syncSettings {\n          isJiraToForecastOneWaySync\n        }\n        id\n      }\n      jiraServer {\n        syncSettings {\n          isJiraToForecastOneWaySync\n        }\n        id\n      }\n      id\n    }\n    modules {\n      moduleType\n      id\n    }\n    person(id: $personId) {\n      id\n      role {\n        id\n        name\n      }\n    }\n    isUsingProjectAllocation\n    isUsingMixedAllocation\n    holidayCalendars(first: 10000) {\n      edges {\n        node {\n          id\n          holidayCalendarEntries(first: 100000) {\n            edges {\n              node {\n                id\n                name\n                year\n                month\n                day\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    allPersons(first: 1000000, onlyActive: true) {\n      edges {\n        node {\n          id\n          firstName\n          lastName\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n    currency\n    harvestEnabled\n    unit4Enabled\n    lockedPeriodYear\n    lockedPeriodMonth\n    lockedPeriodDay\n    labels(first: 1000000, labelType: TASK) {\n      edges {\n        node {\n          id\n          name\n          color\n          category {\n            id\n            name\n          }\n          ...LabelDropdownJS_labels\n        }\n      }\n    }\n    roles(first: 1000000) {\n      edges {\n        ...RoleDropdown_roles\n        node {\n          id\n          name\n        }\n      }\n    }\n    teams(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          teamPersons(first: 1000) {\n            edges {\n              node {\n                id\n                person {\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    customFieldDefinitionsV2(first: 1000) @include(if: $fetchCustomFields) {\n      edges {\n        node {\n          __typename\n          id\n          key\n          displayName\n          entityType\n          ... on TextCustomField {\n            readOnly\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  filters(first: 1000000, projectId: $projectId, filterSection: SCOPING) {\n    edges {\n      node {\n        id\n        name\n        section\n        value\n        updatedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  projects(first: 1000000, excludeRestricted: true) {\n    edges {\n      node {\n        id\n        companyProjectId\n        customProjectId\n        name\n        status\n        isInProjectGroup\n        projectColor\n      }\n    }\n  }\n  project(id: $projectId) {\n    ...ProjectHeader_project\n    ...SecondaryNavigation_project\n    projectFirstDateYear\n    projectFirstDateMonth\n    projectFirstDateDay\n    projectLastDateYear\n    projectLastDateMonth\n    projectLastDateDay\n    baselineTargetPrice\n    baselineTargetMinutes\n    id\n    isNoStaleTasksAllowed\n    name\n    demo\n    budgetWork\n    budgetType\n    defaultPeriodBudgetType\n    budget\n    billable\n    synchBaselineAndScopingDates\n    program {\n      name\n      prefix\n      budgetType\n      members {\n        edges {\n          node {\n            role\n            person {\n              id\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n    sprintTimeBox\n    isInProjectGroup\n    useBaseline\n    projectGroupId\n    status\n    companyProjectId\n    customProjectId\n    estimationUnit\n    minutesPerEstimationPoint\n    timeRegistrations(first: 10000000, onlyProjectRegistrations: true) @include(if: $fetchLazyData) {\n      edges {\n        node {\n          id\n          minutesRegistered\n          billableMinutesRegistered\n          invoiced\n          price\n          updatedAt\n          year\n          month\n          day\n          retainerConflictHandled\n          task {\n            id\n          }\n          person {\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    retainerPeriods(first: 100000) {\n      edges {\n        node {\n          id\n          name\n          startYear\n          startMonth\n          startDay\n          endYear\n          endMonth\n          endDay\n          available\n          periodLength\n          periodPeriodicity\n          periodPriceAmount\n          periodHoursAmount\n          periodBudgetType\n          periodSettingIgnoreForBilling\n          periodSettingSubtractValue\n          periodSettingRollValue\n          periodSettingAddExpenses\n          periodDifferencePriceAmount\n          periodDifferenceHoursAmount\n          sharedPeriodDifferenceHoursAmount\n          sharedPeriodDifferencePriceAmount\n          ignoredRolloverHours\n          ignoredRolloverPrice\n          periodLocked\n          periodLockedTime\n        }\n      }\n    }\n    projectColor\n    projectStartYear\n    projectStartMonth\n    projectStartDay\n    projectEndYear\n    projectEndMonth\n    projectEndDay\n    useManualAllocations\n    remainingAutoCalculated\n    isJiraProject\n    useTaskOwner\n    useTaskFollowers\n    taskLevels\n    useTaskHierarchy\n    useDeliverables\n    deliverables(first: 100000) {\n      edges {\n        node {\n          id\n          name\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    vstsProject\n    vstsAccount\n    harvestProjectId\n    vstsTwoWaySync\n    jiraSubtaskType\n    progress\n    manualProgressOnProjectEnabled\n    manualProgressOnPhasesEnabled\n    manualProgressOnTasksEnabled\n    financialSourceSettings {\n      plannedHours\n      plannedRevenue\n      plannedCost\n      actualRevenue\n      actualCost\n      forecastRevenue\n      actualHours\n      id\n    }\n    jiraCloudProject {\n      id\n    }\n    jiraCloudEpicIds\n    jiraServerProject {\n      id\n    }\n    sageProject {\n      sageProjectId\n      id\n    }\n    statusColumnsV2(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          order\n          jiraStatusId\n          category\n        }\n      }\n    }\n    rateCard {\n      id\n      currency\n      rates(first: 10000) {\n        edges {\n          node {\n            id\n            rate\n            defaultRate\n            startDate\n            role {\n              id\n            }\n          }\n        }\n      }\n      disabledRoles {\n        id\n      }\n    }\n    projectPersons(first: 1000000) {\n      edges {\n        node {\n          id\n          role {\n            id\n            name\n          }\n          person {\n            id\n            firstName\n            lastName\n            fullName\n            initials\n            profilePictureId\n            profilePictureDefaultId\n            active\n            monday\n            tuesday\n            wednesday\n            thursday\n            friday\n            saturday\n            sunday\n            holidayCalendar {\n              id\n            }\n            role {\n              id\n              name\n            }\n            client {\n              id\n            }\n            allocations(first: 1000000, idleTimeOnly: true) {\n              edges {\n                node {\n                  id\n                  monday\n                  tuesday\n                  wednesday\n                  thursday\n                  friday\n                  saturday\n                  sunday\n                  startYear\n                  startMonth\n                  startDay\n                  endYear\n                  endMonth\n                  endDay\n                  idleTime {\n                    isInternalTime\n                    id\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    phases(first: 1000000) {\n      edges {\n        node {\n          baselineTargetPrice\n          baselineTargetMinutes\n          baselineCost\n          inheritDatesFrom\n          progress\n          progressDetails {\n            progress\n            id\n          }\n          phaseBaselineRoles {\n            edges {\n              node {\n                role {\n                  id\n                }\n                baselineMinutes\n                baselinePrice\n                id\n              }\n            }\n          }\n          id\n          projectId\n          name\n          startYear\n          startMonth\n          startDay\n          startFrom\n          deadlineDay\n          deadlineMonth\n          deadlineYear\n          deadlineFrom\n          baselineStartYear\n          baselineStartMonth\n          baselineStartDay\n          baselineDeadlineDay\n          baselineDeadlineMonth\n          baselineDeadlineYear\n          unit4Id\n          jiraId\n          sortOrder\n          phasePersons(first: 10000) {\n            edges {\n              node {\n                id\n                availableMinutes\n                scheduledMinutes\n                person {\n                  id\n                }\n              }\n            }\n          }\n          customFields @include(if: $fetchCustomFields) {\n            edges {\n              node {\n                __typename\n                key\n                displayName\n                value\n                type\n                ... on TextCustomFieldValue {\n                  readOnly\n                }\n                ... on DropdownCustomFieldValue {\n                  options {\n                    id\n                    displayName\n                  }\n                }\n                id\n              }\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    baselineFinancialNumbers: groupedFinancialNumbers(convertToProjectCurrency: true, groupBy: [\"PHASE_BASELINE_ROLE\", \"PHASE\"]) {\n      baselineRevenue\n      baselineTimeAndExpenses\n      baselineCost\n      baselineProfit\n      baselineMargin\n      baselineRatePerHour\n      baselineCostPerHour\n      baselineMinutes\n      phaseBaselineRoleId\n      phaseBaselineExpenseId\n      phaseId\n    }\n    sprints(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          endYear\n          endMonth\n          endDay\n          startYear\n          startMonth\n          startDay\n        }\n      }\n    }\n    tasks(first: 100000, simpleResponse: true, noStaleTasks: $noStaleTasks) {\n      edges {\n        node {\n          id\n          readOnly {\n            isReadOnly\n            id\n          }\n          userCanDeleteTask\n          userCantDeleteTaskReason\n          hasInvoicedTime\n          hasLockedTime\n          hasTimeRegistrations\n          approved\n          name\n          description\n          sortOrder\n          done\n          billable\n          blocked\n          progress @include(if: $fetchLazyData)\n          currentPrice @include(if: $fetchLazyData)\n          actualCost @include(if: $fetchLazyData)\n          plannedCost @include(if: $fetchLazyData)\n          timeLeft @include(if: $fetchLazyData)\n          timeRegistrations(first: 10000) @include(if: $fetchLazyData) {\n            edges {\n              node {\n                id\n                minutesRegistered\n                billableMinutesRegistered\n                price\n                invoiced\n                year\n                month\n                day\n                retainerConflictHandled\n                person {\n                  id\n                  role {\n                    id\n                  }\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          bug\n          latestUiUpdateAt\n          startFrom\n          deadlineFrom\n          startYear\n          startMonth\n          startDay\n          deadlineDay\n          deadlineMonth\n          deadlineYear\n          estimateForecast\n          estimateForecastMinutes\n          estimateForecastPrice\n          totalPriceAtCompletion\n          totalCostAtCompletion\n          allTotalTimeAndExpensesAtCompletion\n          companyTaskId\n          canStart\n          canBeSetToDone\n          highPriority\n          hasDependency\n          jiraId\n          vstsId\n          isUnit4Task\n          subTaskCount\n          parentTaskId\n          deliverableId\n          hasChildren\n          sageIntacctId\n          favoured\n          progressDetails {\n            progress\n            id\n          }\n          owner {\n            id\n            permissions\n          }\n          followers {\n            id\n            permissions\n          }\n          phase {\n            id\n            name\n            startYear\n            startMonth\n            startDay\n            startFrom\n            deadlineDay\n            deadlineMonth\n            deadlineYear\n            deadlineFrom\n          }\n          role {\n            id\n            name\n          }\n          sprint {\n            id\n            name\n            startYear\n            startMonth\n            startDay\n            endYear\n            endMonth\n            endDay\n          }\n          statusColumnV2 {\n            id\n            name\n            category\n          }\n          project {\n            id\n            demo\n            billable\n            estimationUnit\n            minutesPerEstimationPoint\n            projectStartYear\n            projectStartMonth\n            projectStartDay\n            projectEndYear\n            projectEndMonth\n            projectEndDay\n            budgetType\n            projectPerson(personId: $personId) {\n              role {\n                id\n                name\n              }\n              id\n            }\n            program {\n              name\n              prefix\n              budgetType\n              members {\n                edges {\n                  node {\n                    role\n                    person {\n                      id\n                    }\n                    id\n                  }\n                }\n              }\n              id\n            }\n            name\n            status\n            isJiraProject\n            vstsProject\n            vstsAccount\n            vstsTwoWaySync\n            projectColor\n            companyProjectId\n            customProjectId\n            harvestProject {\n              id\n            }\n            unit4Project {\n              id\n              activitiesEnabled\n            }\n            sprintTimeBox\n          }\n          taskLabels {\n            id\n            label {\n              id\n              name\n              color\n            }\n          }\n          taskDismissedNotifications {\n            taskOverrunPredictionDismissed\n            id\n          }\n          assignedPersons {\n            id\n            firstName\n            lastName\n            fullName\n            active\n            email\n            profilePictureId\n            profilePictureDefaultId\n            permissions\n          }\n          thisTaskDependsOn(first: 1000) {\n            edges {\n              node {\n                id\n                type\n                thisDependsOnTask {\n                  id\n                  name\n                  deadlineYear\n                  deadlineMonth\n                  deadlineDay\n                  startYear\n                  startMonth\n                  startDay\n                }\n              }\n            }\n          }\n          customFields @include(if: $fetchCustomFields) {\n            edges {\n              node {\n                __typename\n                key\n                displayName\n                value\n                type\n                ... on TextCustomFieldValue {\n                  readOnly\n                }\n                ... on DropdownCustomFieldValue {\n                  options {\n                    id\n                    displayName\n                  }\n                }\n                id\n              }\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    allocations(first: 100000) {\n      edges {\n        node {\n          id\n          monday\n          tuesday\n          wednesday\n          thursday\n          friday\n          saturday\n          sunday\n          startYear\n          startMonth\n          startDay\n          endYear\n          endMonth\n          endDay\n          person {\n            id\n            role {\n              id\n            }\n            holidayCalendar {\n              id\n            }\n          }\n          project {\n            id\n          }\n          isSoft\n        }\n      }\n    }\n    expenseFinancialNumbers: financialNumbers(searchQuery: {filters: [{field: ROLE, operator: IS, value: \"Um9sZTotMQ==\"}]}, convertToProjectCurrency: true) {\n      allTotalTimeAndExpensesAtCompletion\n    }\n    totalFinancialNumbers: financialNumbers(convertToProjectCurrency: true) {\n      totalCostAtCompletion\n      totalRevenueRecognition\n      totalRevenueProfitAtCompletion\n      totalRevenueMarginAtCompletion\n      forecastMinutes\n      registeredMinutes\n      billableActualMinutes\n      nonBillableActualMinutes\n      billableTotalTimeAndExpensesAtCompletion\n      baselineMinutes\n      allocationMinutes\n      scopeApprovedMinutes\n      remainingMinutes\n      baselineRevenue\n      plannedCost\n      actualCost\n      projectedBillableMinutes\n      projectedNonBillableMinutes\n      projectedTotalMinutes\n      plannedRevenue\n      plannedProfit\n      plannedMargin\n      baselineMargin\n      remainingCost\n      actualRevenue\n      baselineCost\n      baselineProfit\n      billableActualTimeAndExpenses\n      nonBillableActualTimeAndExpenses\n      baselineTimeAndExpenses\n      allTotalTimeAndExpensesAtCompletion\n      taskRegisteredMinutes\n      projectRegisteredMinutes\n    }\n  }\n  psProject(companyProjectId: $projectId) {\n    ...ProjectHeader_psProject\n    id\n  }\n}\n\nfragment RoleDropdown_roles on RoleTypeEdge {\n  node {\n    name\n    id\n  }\n}\n\nfragment SecondaryNavigation_project on ProjectType {\n  companyProjectId\n  customProjectId\n  sprintTimeBox\n  budgetType\n  projectGroupId\n  useBaseline\n  hasInvoices\n  financialSourceSettings {\n    plannedCost\n    plannedRevenue\n    actualCost\n    actualRevenue\n    forecastCost\n    forecastRevenue\n    id\n  }\n}\n\nfragment genericTaskContextMenu_company on Company {\n  id\n  jiraCloudEnabled\n  jiraServerEnabled\n  integrations {\n    jiraCloud {\n      syncSettings {\n        isJiraToForecastOneWaySync\n      }\n      id\n    }\n    jiraServer {\n      syncSettings {\n        isJiraToForecastOneWaySync\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e50102bd8882a71a37ae7f1b4768177a";

export default node;
